import React, { useRef, useState, useEffect } from 'react';
import { CloseOutlined } from '@mui/icons-material';
import { Modal } from 'reactstrap';
import { color } from '~/assets/styles/colors';
import { Form } from '@unform/web';
import { useSelector } from 'react-redux';

import {
	ModalFooterCss,
	Title,
	ButtonFooterCss,
	ButtonCss,
	ModalBodyCss,
	TextPrincipal
} from './styles';





export function ModalGeral(props) {
	const { user } = useSelector((state) => state.auth);
	const {
		toggle,
		setToggle,
		title = 'ATENÇÃO!',
		text = '',
		buttonLeftText = 'CANCELAR',
		buttonRightText = "CONFIRMAR",
		showRightButton = true,
		showLeftButton = true,
		handleRightButton = handleFalseToggle,
		handleLeftButton = handleFalseToggle,
		children
	} = props;
	const formRef = useRef(null);
	const [isMobile, setIsMobile] = useState(false);


	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 768); // Defina a largura de tela que considera como mobile
		};

		handleResize();

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	function handleFalseToggle(){
		setToggle(false)
	}


	return (
		<Modal isOpen={toggle} size="lg">
			<Form ref={formRef}>
				<Title className="d-flex align-items-center justify-content-between">
					{title}
					<ButtonCss
						style={{
							borderRadius: 0,
							padding: 0,
							marginRight: '25px',
							backgroundColor: color.modalGreen,
							border: `1px solid ${color.modalGreen}`,
						}}
						className="d-flex align-items-center justify-content-center"
						onClick={() => {
							setToggle(false)
						}}>
						<CloseOutlined />
					</ButtonCss>
				</Title>
				<ModalBodyCss>
					{text &&
						<TextPrincipal>{text}</TextPrincipal>
					}
					{children}
				</ModalBodyCss>

				<ModalFooterCss>
					{
						showLeftButton &&
						<ButtonFooterCss
							size="sm"
							style={{
								padding: `${isMobile && '14px 48px 14px 48px'}`,
							}}
							onClick={() => {
								setToggle(false)
								handleLeftButton()
							}}>
							{buttonLeftText}
						</ButtonFooterCss>
					}
					{
						showRightButton && (!user?.dados?.is_impersonated || process.env.REACT_APP_ENV === 'HOMOLOG') &&
						<ButtonFooterCss
							size="sm"
							style={{
								padding: `${isMobile && '14px 48px 14px 48px'}`,
							}}
							onClick={() => {
								setToggle(false)
								handleRightButton()}}>
							{buttonRightText}
						</ButtonFooterCss>
					}
				</ModalFooterCss>
			</Form>
		</Modal>
	);
}
